'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('react-redux-form/immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errBlock = function errBlock(model) {
  return _react2.default.createElement(_immutable.Errors, {
    className: 'bisu--errblock',
    show: 'touched',
    model: model,
    messages: {
      required: '* Required.',
      intRequired: '* Required.',
      similar: '* Not match.',
      isEmail: '* Must be a valid email'
    }
  });
};

exports.default = errBlock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-form-error/lib/index.js
// module id = 85
// module chunks = 0